const Delta = ({ value }) => {
	return (
		<div className={Number(value) >= 0 ? 'green-value' : 'red-value'}>
			<span>{Number(value).toFixed(2)}%</span>
		</div>
	);
};

export default Delta;
